<template>
  <div class="app-topbar">
    <div class="topbar-mobile-brand" v-if="isMobile">
      <img class="topbar-mobile-logo" :src="logo" alt="DisplayDeck">
    </div>
    <div class="topbar-new-content" ref="newContent">
      <button v-if="isMobile" class="sidebar-avatar topbar-avatar-btn topbar-new-content-circle"
              aria-label="Neuer Inhalt" @click="newContentOpen = !newContentOpen">+</button>
      <button v-else class="button button-primary topbar-new-content-btn" @click="newContentOpen = !newContentOpen">
        + Neuer Inhalt
        <span class="topbar-new-content-chevron" v-html="getSVG('chevron_down')" />
      </button>
      <div class="profile-popover topbar-new-content-popover" v-if="newContentOpen">
        <button class="popover-item" @click="go('/library')">Datei hochladen</button>
        <button class="popover-item" @click="go('/playlists?create=1')">Playlist erstellen</button>
        <button class="popover-item" @click="go('/screens')">Bildschirm anlegen</button>
      </div>
    </div>
    <div class="topbar-avatar" ref="avatar">
      <button class="sidebar-avatar topbar-avatar-btn" @click="profileOpen = !profileOpen">{{ initials }}</button>
      <ProfilePopover v-if="profileOpen" @close="profileOpen = false" />
    </div>
    <button v-if="isMobile" class="sidebar-avatar topbar-avatar-btn topbar-hamburger-btn"
            @click="$emit('openDrawer')" aria-label="Menü öffnen">
      <span v-html="getSVG('menu')" />
    </button>
  </div>
</template>
<script>
import ProfilePopover from './ProfilePopover.vue';
export default {
  components: { ProfilePopover },
  props: { isMobile: { type: Boolean, default: false } },
  emits: ['openDrawer'],
  data() { return { newContentOpen: false, profileOpen: false }; },
  computed: {
    logo() { return require('@/assets/img/logo-dd.svg'); },
    user() { return this.$store.state.user || {}; },
    initials() {
      return ((this.user.firstName || '?')[0] + (this.user.lastName || '?')[0]).toUpperCase();
    },
  },
  methods: {
    go(path) {
      this.newContentOpen = false;
      this.$router.push(path);
    },
    onDocClick(e) {
      if (this.newContentOpen && this.$refs.newContent && !this.$refs.newContent.contains(e.target)) this.newContentOpen = false;
      if (this.profileOpen && this.$refs.avatar && !this.$refs.avatar.contains(e.target)) this.profileOpen = false;
    },
  },
  mounted() { document.addEventListener('click', this.onDocClick); },
  unmounted() { document.removeEventListener('click', this.onDocClick); },
}
</script>
